module.exports = __webpack_public_path__ + "static/media/transporter.50852bcd.svg";